import {defineStoreCreator} from '@verdure/core'
import menu from './src/menu'
import onlineUser from './src/onlineUser'

export default defineStoreCreator([
    menu, onlineUser
]);
